/**
 * API base URL for CMS backend.
 * Configured via VITE_API_BASE_URL in .env (see .env.example).
 * - Local dev: leave empty — Vite proxies /api/* to localhost:3001
 * - S3 + CloudFront (same domain): leave empty — CloudFront routes /api/* to Cloud Run
 * - Production: set VITE_API_BASE_URL=https://api.offers.curelohealth.com at build time
 */
const raw = (import.meta.env.VITE_API_BASE_URL || '').trim().replace(/\/$/, '');

export function apiUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return raw ? `${raw}${normalized}` : normalized;
}

// Booking app that Book Now buttons deep-link to (catalogId/itemType passed as query params).
// Prod default: booking.curelohealth.com. Override with VITE_BOOKING_BASE_URL for staging builds.
export const BOOKING_BASE_URL = (
  import.meta.env.VITE_BOOKING_BASE_URL || 'https://booking.curelohealth.com/booking'
).trim().replace(/\/$/, '');
